import _taggedTemplateLiteral from "@babel/runtime-corejs3/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import classNames from "classnames";
import { Grid, Icon, makeStyles, Tooltip } from "components/mui";
import { gql } from "@apollo/client";
import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useDLCardBadgesStyles = makeStyles(function (theme) {
  return {
    dataSection: {
      marginRight: "8px",
      fontSize: 14
    },
    dataIcon: {
      fontSize: 14,
      marginBottom: "-2px"
    },
    text: {
      paddingLeft: "4px"
    }
  };
});
var DealroomlistingCardBadges = function DealroomlistingCardBadges(_ref) {
  var _dealroomlisting$like, _dealroomlisting$disl, _context, _dealroomlisting$tour, _dealroomlisting$conv;
  var dealroomlisting = _ref.dealroomlisting;
  var classes = useDLCardBadgesStyles();
  var likedBy = (_dealroomlisting$like = dealroomlisting === null || dealroomlisting === void 0 ? void 0 : dealroomlisting.likedBy) !== null && _dealroomlisting$like !== void 0 ? _dealroomlisting$like : [];
  var dislikedBy = (_dealroomlisting$disl = dealroomlisting === null || dealroomlisting === void 0 ? void 0 : dealroomlisting.dislikedBy) !== null && _dealroomlisting$disl !== void 0 ? _dealroomlisting$disl : [];
  var tourRequestBy = _mapInstanceProperty(_context = (_dealroomlisting$tour = dealroomlisting === null || dealroomlisting === void 0 ? void 0 : dealroomlisting.tourRequests) !== null && _dealroomlisting$tour !== void 0 ? _dealroomlisting$tour : []).call(_context, function (e) {
    return e === null || e === void 0 ? void 0 : e.user;
  });
  var iconsHtml = /*#__PURE__*/_jsxs(Grid, {
    container: true,
    spacing: 1,
    children: [/*#__PURE__*/_jsxs(Grid, {
      item: true,
      className: classes.dataSection,
      children: [/*#__PURE__*/_jsx(Icon, {
        className: classNames("far fa-comment", classes.dataIcon)
      }), /*#__PURE__*/_jsx("span", {
        className: classes.text,
        children: dealroomlisting === null || dealroomlisting === void 0 || (_dealroomlisting$conv = dealroomlisting.conversation) === null || _dealroomlisting$conv === void 0 ? void 0 : _dealroomlisting$conv.commentCount
      })]
    }), /*#__PURE__*/_jsx(Tooltip, {
      disableHoverListener: likedBy.length === 0,
      title: /*#__PURE__*/_jsx(DealroomlistingCardToolTip, {
        users: likedBy,
        title: "Liked By"
      }),
      children: /*#__PURE__*/_jsxs(Grid, {
        item: true,
        className: classes.dataSection,
        children: [/*#__PURE__*/_jsx(Icon, {
          className: classNames("far fa-thumbs-up", classes.dataIcon)
        }), /*#__PURE__*/_jsx("span", {
          className: classes.text,
          children: dealroomlisting === null || dealroomlisting === void 0 ? void 0 : dealroomlisting.likeCount
        })]
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      disableHoverListener: dislikedBy.length === 0,
      title: /*#__PURE__*/_jsx(DealroomlistingCardToolTip, {
        users: dislikedBy,
        title: "Disliked By"
      }),
      children: /*#__PURE__*/_jsxs(Grid, {
        item: true,
        className: classes.dataSection,
        children: [/*#__PURE__*/_jsx(Icon, {
          className: classNames("far fa-thumbs-down", classes.dataIcon)
        }), /*#__PURE__*/_jsx("span", {
          className: classes.text,
          children: dealroomlisting === null || dealroomlisting === void 0 ? void 0 : dealroomlisting.dislikeCount
        })]
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      disableHoverListener: (tourRequestBy === null || tourRequestBy === void 0 ? void 0 : tourRequestBy.length) === 0,
      title: /*#__PURE__*/_jsx(DealroomlistingCardToolTip, {
        users: tourRequestBy,
        title: "Tour requested by"
      }),
      children: /*#__PURE__*/_jsxs(Grid, {
        item: true,
        className: classes.dataSection,
        children: [/*#__PURE__*/_jsx(Icon, {
          className: classNames("far fa-map-marker-plus", classes.dataIcon)
        }), /*#__PURE__*/_jsx("span", {
          className: classes.text,
          children: tourRequestBy === null || tourRequestBy === void 0 ? void 0 : tourRequestBy.length
        })]
      })
    })]
  });
  return iconsHtml;
};
export default DealroomlistingCardBadges;
var useTooltipStyles = makeStyles(function (theme) {
  return {
    dataDiv: {
      marginTop: "4px",
      marginBottom: "4px",
      fontSize: 12,
      fontWeight: 600
    },
    nameDiv: {
      marginTop: "4px"
    },
    container: {
      padding: "8px"
    }
  };
});
var DealroomlistingCardToolTip = function DealroomlistingCardToolTip(_ref2) {
  var title = _ref2.title,
    users = _ref2.users;
  var classes = useTooltipStyles();
  return /*#__PURE__*/_jsx("div", {
    className: classes.container,
    children: (users === null || users === void 0 ? void 0 : users.length) > 0 && /*#__PURE__*/_jsxs("div", {
      className: classes.dataDiv,
      children: [title, ":", _mapInstanceProperty(users).call(users, function (user, index) {
        return /*#__PURE__*/_jsx("div", {
          className: classes.nameDiv,
          children: user === null || user === void 0 ? void 0 : user.fullName
        }, index);
      })]
    })
  });
};
DealroomlistingCardBadges.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment DealroomlistingCardBadgeFragment on DealroomlistingNode {\n        id\n        likeCount\n        dislikeCount\n\n        dislikedBy {\n            id\n            fullName\n        }\n\n        likedBy {\n            id\n            fullName\n        }\n\n        conversation {\n            id\n            commentCount\n        }\n\n        tourRequests {\n            id\n            user {\n                id\n                fullName\n            }\n        }\n    }\n"])));
DealroomlistingCardToolTip.fragments = {
  users: gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        fragment DealroomlistingCardToolTipFragment on UserNode {\n            id\n            fullName\n        }\n    "])))
};